module.exports = __webpack_public_path__ + "img/btcapp.7610bd76.jpg";